import { render, staticRenderFns } from "./Count.vue?vue&type=template&id=27170c7f&scoped=true&lang=pug"
import script from "./Count.vue?vue&type=script&lang=js"
export * from "./Count.vue?vue&type=script&lang=js"
import style0 from "./Count.vue?vue&type=style&index=0&id=27170c7f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27170c7f",
  null
  
)

export default component.exports